import React, { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "../ui/dialog";
import { Input } from "../ui/input";
import { Textarea } from "../ui/textarea";
import { Button } from "../ui/button";
import { Label } from "../ui/label";
import { toast } from "sonner";
import { submitCallback } from "../../lib/api";
import { PhoneCall, Loader2 } from "lucide-react";

export default function RequestCallbackModal({ open, onOpenChange }) {
  const [loading, setLoading] = useState(false);
  const [form, setForm] = useState({ name: "", email: "", phone: "", company: "", best_time: "", message: "" });

  const submit = async (e) => {
    e.preventDefault();
    if (!form.name || !form.email || !form.phone) {
      toast.error("Name, email and phone are required");
      return;
    }
    setLoading(true);
    try {
      const { data } = await submitCallback(form);
      toast.success(data.message);
      onOpenChange(false);
      setForm({ name: "", email: "", phone: "", company: "", best_time: "", message: "" });
    } catch {
      toast.error("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const c = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md" data-testid="request-callback-modal">
        <DialogHeader>
          <div className="inline-flex items-center gap-2 text-primary text-sm font-semibold">
            <PhoneCall className="h-4 w-4" /> Request a Callback
          </div>
          <DialogTitle className="text-2xl">We&apos;ll call you within 24 hours</DialogTitle>
          <DialogDescription>Tell us when to reach you and one of our consultants will get in touch.</DialogDescription>
        </DialogHeader>
        <form onSubmit={submit} className="space-y-3 pt-2">
          <div>
            <Label htmlFor="cb-name">Full name*</Label>
            <Input id="cb-name" data-testid="cb-name-input" value={form.name} onChange={c("name")} required />
          </div>
          <div className="grid grid-cols-2 gap-3">
            <div>
              <Label htmlFor="cb-email">Email*</Label>
              <Input id="cb-email" data-testid="cb-email-input" type="email" value={form.email} onChange={c("email")} required />
            </div>
            <div>
              <Label htmlFor="cb-phone">Phone*</Label>
              <Input id="cb-phone" data-testid="cb-phone-input" value={form.phone} onChange={c("phone")} required />
            </div>
          </div>
          <div>
            <Label htmlFor="cb-company">Company</Label>
            <Input id="cb-company" data-testid="cb-company-input" value={form.company} onChange={c("company")} />
          </div>
          <div>
            <Label htmlFor="cb-time">Best time to call</Label>
            <Input id="cb-time" data-testid="cb-time-input" placeholder="e.g. Weekdays 10am–1pm IST" value={form.best_time} onChange={c("best_time")} />
          </div>
          <div>
            <Label htmlFor="cb-msg">Message</Label>
            <Textarea id="cb-msg" data-testid="cb-message-input" rows={3} value={form.message} onChange={c("message")} />
          </div>
          <Button type="submit" disabled={loading} data-testid="cb-submit-btn" className="w-full bg-primary hover:bg-primary/90 rounded-full h-11">
            {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : "Request Callback"}
          </Button>
        </form>
      </DialogContent>
    </Dialog>
  );
}
